import { APIcaller } from './APIcaller';

/**
 * Fetch channel sales data
 * @param {Array} storeIds - Array of store IDs
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 * @returns {Promise} Promise resolving to channel sales data
 */
export const getChannelSales = async (storeIds, startDate, endDate) =>
  APIcaller.apiPost('/channel-sales/list', {
    storeIds,
    startDate,
    endDate,
  });

export default {
  getChannelSales,
};
